import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronLeft, RotateCcw } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { Money } from "./Money";
import { JournalExpanded } from "./JournalExpanded";
import { refNumberFor } from "./refNumber";

const STATUS_STYLES = {
  posted:            "bg-emerald-500/15 text-emerald-600 border-emerald-500/30",
  draft:             "bg-amber-500/15 text-amber-700 border-amber-500/30",
  approval_pending:  "bg-yellow-500/15 text-yellow-700 border-yellow-500/30",
  reversed:          "bg-rose-500/15 text-rose-600 border-rose-500/30",
};

// صف جدول القيد: قابل للتوسيع بالنقر. يُبرز الرقم المرجعي والفرع والنوع والحالة.
export const JournalRow = ({ entry, branchName, expanded, onToggle, canReverse, onReverse }) => {
  const { t, i18n } = useTranslation();
  const Chev = expanded ? ChevronDown : (i18n.language === "ar" ? ChevronLeft : ChevronDown);
  const canRev = canReverse && entry.status === "posted";

  return (
    <>
      <tr onClick={() => onToggle(entry.id)}
          data-testid={`entry-row-${entry.number}`}
          className="cursor-pointer border-b border-border/40 transition-colors hover:bg-primary/5">
        <td className="px-3 py-3">
          <div className="flex items-center gap-2">
            <Chev className="h-4 w-4 text-muted-foreground" />
            <span className="font-mono text-xs font-bold text-primary" dir="ltr">{entry.number}</span>
          </div>
        </td>
        <td className="px-3 py-3">
          <span className="rounded-md bg-amber-500/12 px-2 py-1 font-mono text-[11px] font-bold text-amber-700" dir="ltr">
            {refNumberFor(entry)}
          </span>
        </td>
        <td className="px-3 py-3 font-mono text-xs" dir="ltr">{entry.date}</td>
        <td className="px-3 py-3 text-xs">{branchName || <span className="text-muted-foreground">—</span>}</td>
        <td className="px-3 py-3">
          <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-bold text-primary">
            {t(`acct.sources.${entry.source}`, entry.source)}
          </span>
        </td>
        <td className="px-3 py-3 text-xs text-muted-foreground min-w-[160px] max-w-[280px] truncate">
          {entry.description || "—"}
        </td>
        <td className="px-3 py-3 text-end">
          <Money value={entry.total_debit} currency={entry.currency} className="text-xs" />
        </td>
        <td className="px-3 py-3 text-end">
          <Money value={entry.total_credit} currency={entry.currency} className="text-xs" dim />
        </td>
        <td className="px-3 py-3">
          <span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${STATUS_STYLES[entry.status] || ""}`}>
            {t(`acct.journal.status.${entry.status}`, entry.status)}
          </span>
        </td>
        <td className="px-3 py-3">
          {canRev ? (
            <NeuButton variant="danger" className="px-2 py-1 text-[10px]"
                       data-testid={`entry-reverse-${entry.id}`}
                       onClick={(e) => { e.stopPropagation(); onReverse(entry); }}>
              <RotateCcw className="h-3 w-3" /> {t("acct.reverse")}
            </NeuButton>
          ) : null}
        </td>
      </tr>
      {expanded ? (
        <tr><td colSpan={10} className="bg-background/40 px-3 py-3">
          <JournalExpanded entry={entry} branchName={branchName} />
        </td></tr>
      ) : null}
    </>
  );
};
